import CRUDActions from './CRUD';
import FanBoxMessage from '../api/fanboxMessages';

class FanBoxMessageCrud extends CRUDActions {
  prefix = 'fanbox';

  get _model() {
    return FanBoxMessage;
  }

  get createPromoAction() {
    return `${this.prefix}_create_promo_action`;
  }

  get createPromoSuccessAction() {
    return `${this.createPromoAction}_success`;
  }

  get createPromoFailAction() {
    return `${this.createPromoAction}_fail`;
  }

  createPromo({product_id, title, content, vip}) {
    return async (dispatch) => {
      dispatch({type: this.createPromoAction});

      try {
        let message = new FanBoxMessage();
        message = await message.createPromoMessage({product_id, title, content, vip});
        dispatch({
          type: this.createPromoSuccessAction,
          message
        });

        return message;
      }

      catch(error) {
        dispatch({
          type: this.createPromoFailAction,
          error
        });

        throw error;
      }
    }
  }

}

export default new FanBoxMessageCrud();



// WEBPACK FOOTER //
// ./src/actions/fanboxMessages.js